import { lazy } from 'react';

const InventoryCountingPage = lazy(() =>
  import('../../components/pages/InventoryCounting/InventoryCountingPage'),
);
const ProductionHandoverPage = lazy(() =>
  import(
    '../../components/pages/ProductionHandoverPage/ProductionHandoverPage'
  ),
);
const MixDeliveriesPage = lazy(() =>
  import('../../components/pages/mix-deliveries/MixDeliveriesPage'),
);
const TransportSimulationPage = lazy(() =>
  import('../../components/pages/transport-stock/TransportSimulationPage'),
);
const TransportStockPage = lazy(() =>
  import('../../components/pages/transport-stock/TransportStockPage'),
);
const PublicPickingCompletePage = lazy(() =>
  import(
    '../../components/pages/mix-deliveries/components/PublicPickingCompletePage'
  ),
);
const BotMonitorPage = lazy(() =>
  import('../../components/pages/BotMonitor/BotMonitorPage'),
);

const StockChangePage = lazy(() => import('../../components/pages/StockChange/StockChangePage'));
export const warehouseRoutes = [
  {path:'/delivery-stock-changes',permission:'stock-change.view',access:'authenticated',roles:['ADMIN','REFERENT','KONTROLER','WHS_SPECIALIST','KIER_ODC_BWH','MISTRZ_ZMIANY'],Component:StockChangePage},
  {
    path: '/inventory-counting',
    permission: 'inventory.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER', 'KIER_ODC_BWH', 'MISTRZ_ZMIANY'],
    Component: InventoryCountingPage,
  },
  {
    path: '/production-handover',
    permission: 'handover.view',
    access: 'authenticated',
    roles: [
      'ADMIN',
      'KONTROLER',
      'KIER_ODC_BWH',
      'STARSZY_MAGAZYNIER',
      'MISTRZ_ZMIANY',
    ],
    Component: ProductionHandoverPage,
  },
  {
    path: '/mix-deliveries',
    permission: 'mix.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER', 'OPERATOR'],
    Component: MixDeliveriesPage,
    roleProp: true,
  },
  {
    path: '/transport-simulation',
    permission: 'transport.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: TransportSimulationPage,
    roleProp: true,
  },
  {
    path: '/transport-stock',
    permission: 'transport.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: TransportStockPage,
    roleProp: true,
  },
  {
    path: '/picking/complete/:token',
    access: 'public',
    roles: null,
    Component: PublicPickingCompletePage,
  },
  {
    path: '/bot-monitor',
    permission: 'bot-monitor.view',
    access: 'authenticated',
    roles: ['ADMIN', 'WHS_SPECIALIST'],
    Component: BotMonitorPage,
  },
];
